import { EMPTY_LIST, EMPTY_STRING } from '../../../constants/common'
import {
  DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_BUILDING,
  DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT,
} from '../DocFlowAddRecipientFields'

export const DocFlowCombiningFieldName = {
  Building: 'building',
  Combined: 'combined',
  FinalFile: 'final_file',
  Flat: 'flat',
  PagesCount: 'pages_count',
  Recipient: 'recipient',
  Role: 'role',
  Status: 'status',
  Uploading: 'uploading',
}

export const DOC_FLOW_COMBINING_FORM_FIELD_ID = 'id'

export const DOC_FLOW_COMBINING_FORM_FIELD_FINAL_FILE_NAME = 'final_file_name'

export const DOC_FLOW_COMBINING_TABLE_FILTER_STATE_URL = `/idwell-api/api/v3/table/filter-states/document-stapling-combinings/all/`

export const DOC_FLOW_COMBINING_TABLE_CONFIG_URL = `/idwell-api/api/v3/table/tables/document-stapling-combinings/`

export const DOC_FLOW_COMBINING_ACTION_ADD_RECIPIENT = 'add_recipient'

export const DOC_FLOW_COMBINING_ACTION_DELETE = 'delete_item'

export const DOC_FLOW_COMBINING_ACTION_EDIT_RECIPIENT = 'edit_recipient'

export const DOC_FLOW_COMBINING_ACTION_EDIT_FINAL_DOCUMENT_TITLE =
  'edit_final_document_title'

export const DOC_FLOW_COMBINING_ACTION_EDIT_SEQUENCE = 'edit_sequence'

export const DOC_FLOW_COMBINING_ACTION_MAKE_COMBINED = 'make_combined'

export const DOC_FLOW_COMBINING_ACTION_MAKE_UNCOMBINED = 'make_uncombined'

// mass actions
export const DOC_FLOW_COMBINING_MASS_ACTION_COMBINED = 'make_combined'

export const DOC_FLOW_COMBINING_MASS_ACTION_UNCOMBINED = 'make_uncombined'

export const DOC_FLOW_COMBINING_MASS_ACTION_EDIT_FINAL_DOCUMENT_TITLE =
  'update_filename'

export const DOC_FLOW_COMBINING_MASS_ACTION_EDIT_SEQUENCE_DOCUMENT =
  'update_uploadings'

export const DOC_FLOW_COMBINING_MASS_ACTION_DELETE = 'delete'

export const DOC_FLOW_COMBINING_MASS_ACTION_EDIT_FINAL_DOCUMENT_TITLE_FIELD =
  'filename'
// end mass actions

export const DOC_FLOW_COMBINING_ADD_RECIPIENT_INITIAL_VALUIES = {
  [DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_BUILDING]: EMPTY_STRING,
  [DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT]: EMPTY_LIST,
}
